<template functional>
  <q-markup-table ref="table" flat bordered class="striped" :wrap-cells="false">
    <thead>
      <slot name="table-head">
        <tr>
          <th v-for="column in props.columns" :key="column" class="text-muted">
            {{ column }}
          </th>
        </tr>
      </slot>
    </thead>

    <tbody>
      <tr v-for="n in 10" :key="n">
        <td>
          <q-skeleton type="text" width="90px" />
        </td>
        <td v-for="m in props.columns.length - 1" :key="m">
          <q-skeleton type="text" />
        </td>
      </tr>
    </tbody>
  </q-markup-table>
</template>

<script>
export default {
  name: 'LoadingTable',
  props: {
    columns: {
      type: Array,
      required: true,
    },
  },
};
</script>
